import React, { useEffect, useState } from 'react'
import styles from './page.module.scss'

const rotatingTexts = ['TMT Bars', 'HR Coils', 'Copper Cathodes', 'Aluminium Ingots', 'MS Angles', 'MS Scrap']

const SearchButton = ({ bannerSearch }) => {
	const [rotateIndex, setRotateIndex] = useState(0)

	useEffect(() => {
		setTimeout(() => {
			setRotateIndex((rotateIndex + 1) % 6)
		}, 1500)
	}, [rotateIndex])

	return (
		<>
			<button className={`${styles.changingPlaceholder} ${bannerSearch && 'm-2'}`}>
				<span>Search for {rotatingTexts[rotateIndex]}</span>
			</button>
		</>
	)
}

export default SearchButton
